import createAPIServices from './createAPIServices'

const api = createAPIServices()

export const getNumberEvents = () => {
    return api.makeAuthRequest({
        url: `/statistical/events`,
        method: 'GET',
    })
}

export const getNumberMedias = () => {
    return api.makeAuthRequest({
        url: `/statistical/medias`,
        method: 'GET',
    })
}

export const getNumberObjects = () => {
    return api.makeAuthRequest({
        url: `/statistical/objects`,
        method: 'GET',
    })
}

export const getNumberUsers = () => {
    return api.makeAuthRequest({
        url: `/statistical/users`,
        method: 'GET',
    })
}
export const getDataChartTaskUser = (type, month, year) => {
    return api.makeAuthRequest({
        url: `/statistical/task/user?type=${type}&month=${month}&year=${year}&begin_time=0&end_time=0`,
        method: 'GET',
    })
}
export const getDataChartTaskSystem = (type, month, year) => {
    return api.makeAuthRequest({
        url: `/statistical/task/system?type=${type}&month=${month}&year=${year}&begin_time=0&end_time=0`,
        method: 'GET',
    })
}
export const getDatachartEventObject = (
    type,
    month,
    year,
    begin_time,
    end_time,
    page_number,
    page_size
) => {
    return api.makeAuthRequest({
        url: `/statistical/events/objects?type=${type}&month=${month}&year=${year}&begin_time=${begin_time}&end_time=${end_time}&page_number=${page_number}&page_size=${page_size}`,
        method: 'GET',
    })
}
export const getDatachartObjectEvent = (
    type,
    month,
    year,
    begin_time,
    end_time,
    page_number,
    page_size
) => {
    return api.makeAuthRequest({
        url: `/statistical/objects/events?type=${type}&month=${month}&year=${year}&begin_time=${begin_time}&end_time=${end_time}&page_number=${page_number}&page_size=${page_size}`,
        method: 'GET',
    })
}
export const getDataCollectedByTier = (type, month, year) => {
    return api.makeAuthRequest({
        url: `/statistical/tiers/newscollected?type=${type}&month=${month}&year=${year}&begin_time=0&end_time=0`,
        method: 'GET',
    })
}
export const getDataChartUserTasks = (
    type,
    begin_time,
    end_time,
    month,
    year
) => {
    return api.makeAuthRequest({
        url: `/statistical/users/tasks?type=${type}&begin_time=${begin_time}&end_time=${end_time}&month=${month}&year=${year}`,
        method: 'GET',
    })
}
export const getDatachartOrgTask = (
    type,
    month,
    year,
    begin_time,
    end_time
) => {
    return api.makeAuthRequest({
        url: `/statistical/organs/tasks?type=${type}&month=${month}&year=${year}&begin_time=${begin_time}&end_time=${end_time}`,
        method: 'GET',
    })
}
export const getDataUsercollected = (
    type,
    month,
    year,
    begin_time,
    end_time
) => {
    return api.makeAuthRequest({
        url: `/statistical/users/newscollected?type=${type}&month=${month}&year=${year}&begin_time=${begin_time}&end_time=${end_time}`,
        method: 'GET',
    })
}
